import React, { Component } from 'react';
import { CBBenefitsStyles } from './CBBenefitsStyles';
import { cbBenefits } from '../../data/cbBenefitsData';

class CBBenefitsComponent extends Component {
  handleModalOpen = () => {
    this.props.handleModalOpen();
  };

  render() {
    return (
      <CBBenefitsStyles>
        <div className="container">
          <h2>Benefits of Using ClientBooks</h2>
          <div>
            {cbBenefits.map((benefit, i) => (
              <div className="row benefit-wrap" key={benefit.benefit_title}>
                <div className={['col-md-6', i % 2 ? '' : 'order-md-1'].join(' ')}>
                  <div className="benefit">
                    <h3>{benefit.benefit_title}</h3>
                    <div className="sub-title">{benefit.benefit_sub_title}</div>
                    <ul className="fancy-list">
                      {benefit.benefit_list.map(item => (
                        <li key={item.benefit_list_item}>{item.benefit_list_item}</li>
                      ))}
                    </ul>
                    <div className="row">
                      <div className="col-sm-6">
                        <button
                          type="button"
                          className="btn btn-primary btn-block"
                          onClick={this.handleModalOpen}
                        >
                          Start for Free
                        </button>
                      </div>
                    </div>
                    <div className="no-cc">No Credit Card Needed</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="benefit-testimonial-wrap">
                    <img
                      src={benefit.image.url}
                      alt={benefit.image.alt}
                      className="benefit-screenshot"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </CBBenefitsStyles>
    );
  }
}

export default CBBenefitsComponent;
